"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinChildren = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var shouldReplaceKey = function shouldReplaceKey(key) {
  return !key || /\.[0-9]+/.test(key);
};

var joinChildren = function joinChildren(children, seperator) {
  var kids = [];

  var arr = _react.default.Children.toArray(children);

  if (!arr) return null;

  for (var i = 0; i < arr.length; i++) {
    if ((0, _typeof2.default)(arr[i]) === 'object') {
      var el = arr[i];
      kids.push(_react.default.cloneElement(el, (0, _objectSpread2.default)({}, el.props, {
        key: shouldReplaceKey(el.key) ? "el-".concat(i) : el.key
      })));
    } else {
      kids.push(arr[i]);
    }

    if (i < arr.length - 1) {
      kids.push(_react.default.cloneElement(seperator, (0, _objectSpread2.default)({}, seperator.props, {
        key: "join-".concat(i)
      })));
    }
  }

  return kids;
};

exports.joinChildren = joinChildren;